import api from '../services/api';
import { loginAccount, registerAccount } from '../utils/login-redirected';
import { $Q } from '../utils/query-selector';

/**
   * It handles the facebook response
   * @param {Object} response : It is the facebook response
   */
async function handleCredentialsResponse({email, name, id}) {
  const givenName = name.split(" ")[0];
  const familyName = name.split(" ")[1];
  const shopifyUser = await api.verifyAccount(email);

  if (shopifyUser.exists) {
    loginAccount(email, id);
  } else {
    const params = { email:email, hashedToken: id, givenName, familyName};
    registerAccount(params);
  }
}

/**
 * get info all user permision
 */
async function getDataUser() {
  await FB.api('/me', {fields: 'name,email'}, (response) => {
    handleCredentialsResponse(response);
  });
}

/**
 * eval status login
 * @param {Object} response : It is the facebook response
 */
function statusChangeCallback(response) {
  if (response.status === 'connected') { // Logged into your webpage and Facebook.
    getDataUser();
  }
}
/**
   * event click init login facebook
   */
function initEventClickLogin() {
  FB.login((response) => {
    statusChangeCallback(response)
  }, {scope: 'public_profile,email'});
}

export const facebookLogin = () => {
  window.addEventListener('load', () => {
    FB.init({
      appId: '324868906765916',
      autoLogAppEvents: true,
      xfbml: true,
      version: 'v15.0',
    });

    $Q(".button-login-fb")
      .addEventListener("click", initEventClickLogin)
  });
}
 